export const getCompressedImageUrl = (oldUrl = '') =>
  oldUrl
    .replace('http://docs.pgiconsult.fr/rct/kepler/', 'https://ik.imagekit.io/eDonec/api/')
    .replace('http://docs.pgiconsult.fr/prod/kepler/', 'https://ik.imagekit.io/eDonec/api/')
    .replace('https://docs.pgiconsult.fr/prod/kepler/', 'https://ik.imagekit.io/eDonec/api/')
    .replace('https://docs.pgiconsult.fr/rct/kepler/', 'https://ik.imagekit.io/eDonec/api/');
